import { Navigate, Outlet } from "react-router-dom";

export default function HandleAccessRoute(props) {
  let component;
  let isAuthenticated = false;
  const getToken = sessionStorage.getItem("token_login");

  if (getToken) {
    // jika ini ada isi token
    isAuthenticated = true;
  }
  if (isAuthenticated) {
    component = <Outlet />;
  } else {
    // saat mau akses misalnya "/dashboard"
    // dan JWT token tidak ada, maka react router DOM langsung direact ke login
    component = <Navigate to="/" />;
  }
  return component;
}
